import { EntityListTypeGroup } from './skuEntityListsTypes';
import React from 'react';
import { DataTable, Label, Panel, Text } from '@ydistri/ds';
import { EntityListTypeName } from '@ydistri/api-sdk';
import SkuEntityListsTable from './SkuEntityListsTable';
import { ColumnsType } from 'antd/es/table';
import EntityListTypeBadge from '../../../../components/domain/EntityLists/EntityListTypeBadge';

interface SkuEntityListsGroupTableProps {
  data: EntityListTypeGroup[];
}

const rowKeyProvider = (record: EntityListTypeGroup) => record.type;

const columns: ColumnsType<EntityListTypeGroup> = [
  {
    key: 'listsCount',
    title: 'Lists count',
    align: 'center',
    width: '6rem',
    render: (group: EntityListTypeGroup) => {
      return <Text>{group.lists.length}</Text>;
    },
  },
  {
    key: 'typeBadge',
    title: '',
    dataIndex: 'type',
    width: '3rem',
    align: 'center',
    render: (type: EntityListTypeName) => <EntityListTypeBadge typeNames={[type]} />,
  },
  {
    key: 'typeName',
    title: 'Entity List Type',
    dataIndex: 'type',
    render: (type: EntityListTypeName) => <Label>{type}</Label>,
  },
];

const customExpanded = {
  expandRowByClick: true,
  expandedRowRender: (record: EntityListTypeGroup) => {
    return (
      <Panel $margin="12pt">
        <SkuEntityListsTable entityLists={record.lists} entityListsTypeName={record.type} />
      </Panel>
    );
  },
};

/**
 * Table component to display groups of entity lists by their type. Each row is expandable to show the lists of that type.
 * @param data
 */
const SkuEntityListsGroupTable: React.FC<SkuEntityListsGroupTableProps> = ({ data }) => {
  return (
    <DataTable<EntityListTypeGroup>
      columns={columns}
      dataSource={data}
      id="EntityListTypeGroupTable"
      showHeader
      showBorder
      rowKey={rowKeyProvider}
      expandable={customExpanded}
    />
  );
};

export default SkuEntityListsGroupTable;
